import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { AuthService } from './auth.service';

export const authResolver: ResolveFn<void> = async () => {
  const authService = inject(AuthService);

  if (authService.currentUser()) {
    return; // already loaded, e.g. after login
  }

  try {
    await authService.loadCurrentUser();
  } catch {
    // no token or expired ,authGuard will redirect to /login
  }
};
